var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{staticClass:"gray-bg",staticStyle:{"margin":"0 0 0 0"},attrs:{"id":"page-wrapper"}},[_c('page-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticClass:"padding-20"}),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('voltar-ao-topo')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e2e7c94","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/LayoutPaginaAcessos.vue
// module id = 2007
// module chunks = 0